import type { ValidChainId, } from "@bracket/types";

export const URLS = {
	TWITTER: "https://twitter.com/Bracket_fi",
	DISCORD: "https://discord.gg/bracket",
	TELEGRAM: "https://t.me/bracket_community",
};

export const API_URLS = {
	BARS: "/api/bars",
	IDENT: "/api/ident",
	GRAPHQL_API: "/api/vaults/graphql",
};

export const ENVIRONMENT = globalThis.location.hostname.startsWith("app") ? "PRODUCTION" : "DEVELOPMENT";

export const PERSONA_ENVIRONMENT_ID = (
	ENVIRONMENT === "PRODUCTION"
		? import.meta.env.VITE_PERSONA_PROD_ENVIRONMENT_ID
		: import.meta.env.VITE_PERSONA_DEV_ENVIRONMENT_ID
);

export const EXPLORER_MAP = new Map<ValidChainId, { name: string, url: string }>([
	[1, {"name": "etherscan", "url": "https://etherscan.io"}]
]);

export const PROD_ENV = globalThis.location.hostname.startsWith("app") ? "PRODUCTION" : "DEVELOPMENT";
export const NODE_ENV = globalThis.location.hostname.startsWith("app") ? "PRODUCTION" : "DEVELOPMENT";
